export default "__VITE_ASSET__0d6aa398__"